import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { HttpParams, HttpResponse } from '@angular/common/http';
import { LookupDetail } from 'src/app/core/models/lookup-detail.model';
import { LiftEngineService } from './lift-engine.service';


@Injectable({ providedIn: 'root' })
export class LiftEngineLookupResolver implements Resolve<HttpResponse<LookupDetail[]>> {
  constructor(
    private liftEngineService: LiftEngineService
  ) { }

  resolve() {
    const httpParams = new HttpParams()
      .set('orderby', 'Title asc');
    return this.liftEngineService.get(httpParams);
  }
}
